import React from 'react'

function Section2() {
  return (
    <div className='row'>
        <div className='section2-container col-md-12 col-12'>
          <h3 className=''>What is MLS.com®?</h3>
          <p className='section12-container--divider mt-5 mb-5'></p>
          <p>
              MLS.com® is a free MLS search to find real estate listings for sale by Realtors® and other realty professionals that are members of your local MLS Multiple Listing Service. MLS.com® also features foreclosures, new construction, international properties and real estate classes. Find homes for sale, new homes and resale homes, new construction, acreage, lots, land, commercial properties and investment properties. MLS.com is independently owned and operated and is not affiliated with any of the over 900 local MLS systems. On MLS.com you can list your properties and reach our global audience.
          </p>
      </div>
    </div>
  )
}

export default Section2